/* eslint-disable */
// VENDORED unchanged from learning_brain_poc/rhs4_lod.js (W7b / F3, POC commit 6ad5075e). Side-effect module: sets a window global.
// Chat v4 right-hand side: the line of diagnosis bar above the evidence map (Diagnosis tab), shown only when /api/info says lod.enabled.
// window.Rhs4Lod = {render(state, deps), tag(state, deps), reset()}; deps = {h, cleanLabel, fire, cards, ruledIds}. All text goes in as text nodes.
// Works like 'Investigate this cause' on the map: pick a line chip, then 'Check only this line'; the chat sends focus_lod every turn
// (chat4.js) until 'Check all lines' or until the server drops it (response focus_lod null: the line has no open cause left).
(function () {
  'use strict';

  // wording (2026-10-22 review): the header says plainly what is being checked; the two actions say what they do
  const TITLE = 'Line of diagnosis', LEADING = 'Leading line: ', CHOSEN = 'Checking only: ', NONE_YET = 'All lines';
  const AUTO_NOTE = 'All lines are checked. Pick a line below to check only that one.', LABEL_JOIN = ', ';
  const TAG_AUTO = 'Leading line: ', TAG_CHOSEN = 'Checking only: ';
  const INVESTIGATE = 'Check only this line', INVESTIGATE_TIP = 'Only the possible causes in the selected line are checked. The others are paused, not deleted.';
  const PICK_FIRST = 'Select a line above first.', LOCKED_TIP = 'Not available while the chat waits for a fix result or is closed.';
  const BACK = 'Check all lines', BACK_TIP = 'Check the possible causes of every line again.';
  // always shown while a line is chosen, so a switch is never silent; n = the line's causes when the server or the definitions say
  const chosenNote = (name, n) => 'Checking only ' + name + (n === null ? '' : ' (' + n + ' cause' + (n === 1 ? '' : 's') + ')') + '. Other lines are paused.';
  const ALL_LINES = 'Lines', CHOSEN_TIP = 'The line you chose.';
  const INFO_LABEL = 'What is a line of diagnosis?';
  const INFO = [
    'A line of diagnosis is a group of possible causes that belong together, for example DC, Policy or General.',
    'By default all lines are checked at once.',
    'Check only this line: only the possible causes inside that line are checked, and the questions follow them. Causes in other lines are paused, not deleted. A cause you chose with Investigate this cause always stays.',
    'When the chosen line has no open cause left, all lines are checked again by themselves. You can then pick another line.',
  ];
  const LEAD_TIP = 'The leading possible cause is in this line.';      // a cause tagged in two lines leads in both
  const openTip = n => n + ' open possible cause' + (n === 1 ? '' : 's') + ' in this line.';
  const totalTip = n => n + ' possible cause' + (n === 1 ? '' : 's') + ' in this line.';

  // kept across re-renders of the panel: the chip the engineer selected (not yet investigated) and the open info text
  let picked = null, infoOpen = false;

  const lodOf = state => (state.info || {}).lod;
  const enabled = lod => !!(lod && lod.enabled && (lod.definitions || []).length);
  const countOf = v => (Array.isArray(v) ? v.length : (typeof v === 'number' && Number.isFinite(v) ? v : null));
  function lineLabel(state, d, nid) {
    const def = ((lodOf(state) || {}).definitions || []).find(x => x.nid === nid);
    const focus = state.lodFocus && state.lodFocus.nid === nid ? state.lodFocus.label : '';
    return d.cleanLabel((def && def.label) || focus) || nid;
  }

  // open causes per line from the latest cards; before the first message there are none, so the line's size from the definitions
  function counts(state, lod, d) {
    const ruled = d.ruledIds(), all = d.cards(), open = all.filter(c => !c.excluded && !ruled.has(c.pid));
    const linesOf = c => (c.lods && c.lods.length ? c.lods : [lod.general]);      // an untagged cause counts in the General line
    const leadPid = state.diag ? state.diag.pid : (open[0] || {}).pid;
    const leadCard = all.find(c => c.pid === leadPid);
    const leading = new Set(leadCard ? linesOf(leadCard) : []);
    const live = all.length > 0;
    return lod.definitions.map(def => {
      const n = live ? open.filter(c => linesOf(c).includes(def.nid)).length : countOf(def.n_causes);
      return {def, n, live, lead: leading.has(def.nid)};
    });
  }

  // the current line(s): the chosen one, else every line of the leading open cause (one cause can sit in two lines)
  function currentLabel(state, d, rows) {
    const focus = state.focusLod || '';
    if (focus) return lineLabel(state, d, focus);
    const lead = rows.filter(r => r.lead).map(r => d.cleanLabel(r.def.label) || r.def.nid);
    return lead.length ? lead.join(LABEL_JOIN) : NONE_YET;      // before the first message no cause leads yet
  }

  // every line is a chip with its count; the current line(s) keep the old lead highlight; the chosen line cannot be picked again
  function chip(row, state, d, repaint) {
    const nid = row.def.nid, label = d.cleanLabel(row.def.label) || nid, chosen = state.focusLod === nid, on = picked === nid;
    const lead = state.focusLod ? chosen : row.lead;
    const desc = d.cleanLabel(row.def.description || '');
    const tips = [desc, row.n === null ? '' : (row.live ? openTip(row.n) : totalTip(row.n)), chosen ? CHOSEN_TIP : (row.lead ? LEAD_TIP : '')].filter(Boolean);
    return d.h('button', {type: 'button', class: 'v4-lod-chip' + (lead ? ' lead' : '') + (on ? ' on' : '') + (row.live && !row.n ? ' empty' : ''),
      'data-lod': nid, 'aria-pressed': String(on), 'aria-current': chosen ? 'true' : null, title: tips.join(' ') || null,
      onclick: () => { if (chosen) return; picked = on ? null : nid; repaint(); }},      // a second click clears the selection, like a map node
      d.h('span', null, label), row.n === null ? null : d.h('span', {class: 'v4-lod-n'}, String(row.n)));
  }

  // the chosen line's status line: the server's count ({kept}: a count or a list), else the definitions' n_causes
  function focusNote(state, d, row) {
    const kept = countOf((state.lodFocus || {}).kept), n = kept !== null ? kept : (row ? countOf(row.def.n_causes) : null);
    return d.h('p', {class: 'v4-lod-note chosen', role: 'status'}, chosenNote(lineLabel(state, d, state.focusLod), n));
  }

  function paint(box, state, d) {
    const lod = lodOf(state), focus = state.focusLod || '', can = state.canOverride !== false;
    const rows = counts(state, lod, d);
    if (picked && (picked === focus || !rows.some(r => r.def.nid === picked))) picked = null;
    const repaint = () => paint(box, state, d);
    const info = d.h('div', {class: 'v4-lod-info', id: 'v4-lod-info', hidden: !infoOpen}, INFO.map(t => d.h('p', null, t)));
    const infoBtn = d.h('button', {type: 'button', class: 'v4-lod-i', 'aria-label': INFO_LABEL, title: INFO_LABEL, 'aria-expanded': String(infoOpen),
      'aria-controls': 'v4-lod-info', onclick: () => { infoOpen = !infoOpen; repaint(); }}, 'i');
    const focusDef = rows.find(r => r.def.nid === focus);
    const focusDesc = focusDef ? d.cleanLabel(focusDef.def.description || '') : '';
    const pickedDef = rows.find(r => r.def.nid === picked);
    const pickedDesc = pickedDef ? d.cleanLabel(pickedDef.def.description || '') : '';
    const go = d.h('button', {type: 'button', class: 'v4-small v4-lod-go' + (picked && can ? ' lit' : ''), disabled: !picked || !can,
      title: !can ? LOCKED_TIP : (picked ? INVESTIGATE_TIP : PICK_FIRST),
      onclick: () => { const nid = picked; picked = null; d.fire('onFocusLod', nid); }}, INVESTIGATE);
    const back = focus ? d.h('button', {type: 'button', class: 'v4-small v4-lod-back', disabled: !can, title: can ? BACK_TIP : LOCKED_TIP,
      onclick: () => { picked = null; d.fire('onFocusLod', null); }}, BACK) : null;
    box.replaceChildren(...[      // replaceChildren(null) would print the word null
      d.h('div', {class: 'v4-lod-head'},
        d.h('span', {class: 'v4-lod-title'}, focus ? CHOSEN : LEADING),
        d.h('span', {class: 'v4-lod-current' + (focus ? ' chosen' : '')}, currentLabel(state, d, rows)),
        infoBtn, back),
      focusDesc ? d.h('p', {class: 'v4-lod-desc'}, focusDesc) : null,
      focus ? focusNote(state, d, focusDef) : d.h('p', {class: 'v4-lod-note'}, AUTO_NOTE),
      info,
      d.h('div', {class: 'v4-lod-chips', role: 'group', 'aria-label': ALL_LINES},
        d.h('span', {class: 'v4-lod-sub'}, ALL_LINES), rows.map(r => chip(r, state, d, repaint)), go),
      pickedDesc ? d.h('p', {class: 'v4-lod-desc'}, pickedDesc) : null].filter(Boolean));
  }

  function render(state, d) {
    if (!enabled(lodOf(state))) { picked = null; return null; }
    const box = d.h('div', {class: 'v4-lod', role: 'group', 'aria-label': TITLE, 'data-key': 'lod'});
    paint(box, state, d);
    return box;
  }

  // the current line(s) next to the map's heading
  function tag(state, d) {
    const lod = lodOf(state);
    if (!enabled(lod)) return null;
    return d.h('span', {class: 'v4-lod-tag' + (state.focusLod ? ' chosen' : '')}, (state.focusLod ? TAG_CHOSEN : TAG_AUTO) + currentLabel(state, d, counts(state, lod, d)));
  }

  // a new chat or another category: no chip stays selected from the previous one
  function reset() { picked = null; }

  window.Rhs4Lod = {render, tag, reset};
})();
